import React, { useState } from 'react';
import { Alert, Button, Icon, Text, Input, TextArea } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { Container } from 'styles';
import { useUser } from 'hooks/use-user.hook';
import { useCreateCampaignSubmission } from 'hooks/use-create-campaign-submission.hook';
import { translateError } from 'utils/errors/translate-error';
import { useAdvocacyContext } from 'contexts/advocacy';
import { Tip } from '../message.style';
import { getGreeting } from './email-form.utils';

const getCopy = copyFor('advocacy.message');

interface Props {
  onSuccess: () => void;
}

export const EmailForm = (props: Props) => {
  const { onSuccess } = props;
  const { representatives, campaign } = useAdvocacyContext();
  const {
    id: advocacyCampaignId,
    subjectLine,
    editableBody,
    uneditableBody: uneditableEmailBody,
  } = campaign;
  const [emailSubject, setEmailSubject] = useState<string>(subjectLine);
  const [emailBody, setEmailBody] = useState<string>(editableBody);

  const user = useUser();
  const [createCampaignSubmission, { error, loading }] =
    useCreateCampaignSubmission({
      advocacyCampaignId,
      emailBody,
      emailSubject,
      representatives,
    });

  const handleSubmit = async e => {
    e.preventDefault();
    await createCampaignSubmission();
    onSuccess();
  };

  const sublabel = (
    <Text opacity="medium" margin={{ bottom: '16px', top: '16px' }}>
      {getGreeting(representatives)}
    </Text>
  );

  return (
    <Container maxWidth="540px">
      <Text tag="h1" margin={{ bottom: '32px' }} textStyle="heading800">
        {getCopy('title')}
      </Text>
      <Tip>
        <div>
          <Icon icon="Pencil" margin={{ right: '8px', top: '5px' }} scale={3} />
        </div>
        <Text textStyle="paragraph400">{getCopy('tip')}</Text>
      </Tip>
      <form onSubmit={handleSubmit}>
        <Input
          value={emailSubject}
          label={getCopy('subjectLabel')}
          name="email subject"
          onChange={setEmailSubject}
          margin={{ bottom: '32px' }}
        />
        <TextArea
          id="email-body"
          name="email body"
          label={getCopy('bodyLabel')}
          sublabel={sublabel}
          value={emailBody}
          onChange={value => setEmailBody(value)}
          margin="0 0 16px 0"
          rows={20}
        />
        <Text opacity="medium">{uneditableEmailBody}</Text>
        <Text margin={{ top: '16px' }} opacity="medium">
          {getCopy('signOff')}
        </Text>
        <Text className="notranslate" opacity="medium">
          {user.data?.name || getCopy('loadingSignature')}
        </Text>
        {error && (
          <Alert margin={{ bottom: '32px' }}>{translateError(error)}</Alert>
        )}
        <Button
          loading={loading}
          margin={{ bottom: '24px', top: '32px' }}
          fullWidth={true}
          type="submit"
        >
          {getCopy('button')}
        </Button>
      </form>
    </Container>
  );
};
